import React from "react";
import "./TermsUse.css"; // Importando o arquivo CSS para os estilos

const TermsUse: React.FC = () => {
  return (
    <div className="nc-terms-use">
      <div className="container-terms">
        <h1>Termos de uso</h1>
        <p className="p-term">
          Contrato revisado pela última vez: 26/03/2024
        </p>
        <p className="p-term">
          Este contrato é celebrado entre Radar&Você Marketing Ltda, com sede em Rua Gomes de Carvalho, 1266 Cj 78 inscrita no CNPJ/CPF sob o nº 49.835.365/0001-25, doravante referida como "Responsável pelo Tratamento de Dados", e [Usuária], portadora do CPF nº [Número de CPF], residente em [Endereço], doravante referida como "Usuária".
        </p>

        <h2>Cadastro e Acesso:</h2>
        <p className="p-term">
          1.1. A participação na comunidade está reservada exclusivamente a mulheres cadastradas em nosso banco de dados.
        </p>
        <p className="p-term">
          1.2. O cadastro requer informações como nome, e-mail, cidade e outras informações pertinentes.
        </p>

        <h2>Compartilhamento Seletivo de Informações:</h2>
        <p className="p-term">
          2.1. Suas informações serão compartilhadas seletivamente apenas com outros membros da comunidade para facilitar a interação entre as usuárias.
        </p>

        <h2>Acesso e Controle Individual:</h2>
        <p className="p-term">
          3.1. Cada usuária tem controle total sobre suas informações pessoais, podendo decidir compartilhar ou não determinadas informações com outras membros da comunidade.
        </p>

        <h2>Dicas de Produtos e Serviços:</h2>
        <p className="p-term">
          4.1. O acesso às dicas exclusivas de produtos e serviços em várias cidades do Brasil e no exterior está condicionado ao cadastro e à participação ativa na comunidade.
        </p>

        <h2>Menores de Idade:</h2>
        <p className="p-term">
          5.1. A participação na comunidade é restrita a mulheres maiores de idade. Menores de idade devem obter o consentimento de um responsável legal.
        </p>

        <h2>Finalidade da Comunidade:</h2>
        <p className="p-term">
          6.1. A comunidade tem o propósito de compartilhar informações geradas pela própria comunidade, experiências e dicas exclusivas de produtos e serviços entre mulheres.
        </p>

        <h2>Uso de Cookies:</h2>
        <p className="p-term">
          7.1. Utilizamos cookies para melhorar a experiência na comunidade. As configurações de cookies podem ser gerenciadas nas opções do seu navegador.
        </p>

        <h2>Propriedade Intelectual:</h2>
        <p className="p-term">
          8.1. O conteúdo exclusivo da comunidade é protegido por direitos autorais. O compartilhamento não autorizado é estritamente proibido.
        </p>

        <h2>Uso Aceitável:</h2>
        <p className="p-term">
          9.1. Ao participar da comunidade, você concorda em seguir as regras estabelecidas e não se envolver em atividades prejudiciais à integridade da comunidade ou suas participantes.
        </p>

        <h2>Responsabilidade da Usuária:</h2>
        <p className="p-term">
          10.1. Cada usuária é responsável por manter a confidencialidade de suas credenciais de acesso e por suas atividades na comunidade, incluindo todas as dicas de produtos e serviços compartilhadas.
        </p>

        <h2>Alterações no Termo:</h2>
        <p className="p-term">
          11.1. Reservamo-nos o direito de fazer alterações nestes termos para melhorar a comunidade. As alterações serão notificadas através da plataforma.
        </p>

        <h2>Encerramento da Conta:</h2>
        <p className="p-term">
          12.1. A usuária pode encerrar sua participação na comunidade a qualquer momento, sujeito aos termos especificados nos Termos de Uso.
        </p>

        <h2>Procedimentos em caso de violação de dados:</h2>
        <p className="p-term">
          13.1. Em caso de violação de dados, serão seguidos procedimentos adequados, incluindo notificação aos usuários afetados e às autoridades regulatórias competentes, conforme exigido pela legislação aplicável.
        </p>

        <h2>Retenção de Dados:</h2>
        <p className="p-term">
          14.1. Os dados pessoais serão retidos pelo período necessário para cumprir as finalidades descritas neste contrato e serão deletados quando não forem mais necessários.
        </p>

        <h2>Direitos das Titulares dos Dados:</h2>
        <p className="p-term">
          15.1. A usuária tem o direito de acessar, corrigir, atualizar ou solicitar a exclusão de seus dados pessoais, conforme permitido pela legislação aplicável.
        </p>

        <h2>Transferências Internacionais de Dados:</h2>
        <p className="p-term">
          16.1. Ao participar da comunidade, a usuária concorda com a transferência de suas informações para outros membros, incluindo aquelas localizadas fora do seu país de residência, e com as medidas de segurança implementadas para proteger os dados durante essas transferências.
        </p>

        <h2>Base Legal para o Processamento de Dados:</h2>
        <p className="p-term">
          17.1. O processamento de dados pessoais será realizado com base em uma das bases legais previstas na legislação de proteção de dados aplicável, como consentimento do usuário, cumprimento de obrigações contratuais, entre outras.
        </p>

        <h2>Informações de Contato do Controlador de Dados:</h2>
        <p className="p-term">
          18.1. Para quaisquer dúvidas ou preocupações sobre a proteção de dados, entre em contato conosco através das informações fornecidas na plataforma.
        </p>

        <h2>Segurança dos Dados:</h2>
        <p className="p-term">
          19.1. Comprometemo-nos a implementar medidas de segurança adequadas para proteger os dados das usuárias contra acesso não autorizado ou divulgação.
        </p>

        <h2>Consentimento Explícito:</h2>
        <p className="p-term">
          20.1. Ao aceitar estes termos, a usuária concorda expressamente com o processamento de seus dados pessoais de acordo com as disposições deste contrato.
        </p>

        <h2>Cooperação com Autoridades Regulatórias:</h2>
        <p className="p-term">
          21.1. Comprometemo-nos a cooperar plenamente com as autoridades regulatórias em caso de violação de dados ou outras questões relacionadas à proteção de dados.
        </p>

        <h2>Resolução de Disputas:</h2>
        <p className="p-term">
          22.1. Quaisquer disputas decorrentes deste contrato serão resolvidas de forma amigável entre as partes. Se a disputa não puder ser resolvida amigavelmente, as partes concordam em submeter-se à jurisdição dos tribunais competentes da cidade de São Paulo, SP, Brasil.
        </p>

        <h2>Atualizações na Política de Privacidade:</h2>
        <p className="p-term">
          23.1. A política de privacidade e o contrato de proteção de dados serão revisados periodicamente e atualizados conforme necessário. As alterações serão comunicadas aos usuários através da plataforma.
        </p>

        <p className="p-term">
          Ao participar da nossa comunidade, você concorda com estes Termos de Uso, Política de Privacidade e Contrato de Proteção de Dados.
        </p>

        {/* <p className="p-term">
          [Assinatura do Responsável pelo Tratamento de Dados] [Data]
        </p>
        <p className="p-term">
          [Assinatura da Usuária] [Data]
        </p> */}
      </div>
    </div>
  );
};

export default TermsUse;
